module.exports = __webpack_public_path__ + "static/media/I2.83a03660.png";